import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  IdNameModel,
  ListRequestOfBaseFilter,
} from "services/KnowfullyAdminClient";

type SelectOrganizationStatusProps = Omit<
  AutocompleteWithQueryProps<IdNameModel>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectOrganizationStatus = (props: SelectOrganizationStatusProps) => {
  const { formatMessage: t } = useIntl();
  const { organizationService } = useGlobalContext();

  const fetchedData = useQuery(["getOrganizationStatuses"], () =>
    organizationService.getOrganizationStatuses(
      ListRequestOfBaseFilter.fromJS({
        sortField: "name",
      })
    )
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="name"
      fetchedData={fetchedData}
      failMessage={t({ id: "fetchError" })}
    />
  );
};

export default SelectOrganizationStatus;
